import * as React from 'react';

import {FilterChip} from './FilterChip';
import {GaEventOptions} from '../../../client/ga/ga.functions';
import {SearchResult} from '../search.types';
import {URLBuilder} from '../../../server/tools/url-builder/url-builder.class';

interface FilterChipsProps {
    buildURL: URLBuilder;
    pushGaEvent?: (gaEventOptions: GaEventOptions) => void;
    resultList: SearchResult;
}

const SearchSlashQuote = /\\"/g;
const FacetReplace = /-?\d*\|/;

export const FilterChips = ({buildURL, pushGaEvent, resultList}: FilterChipsProps) => {
    /**
     * Template
     */
    if (resultList.currentFilters.length > 0 && resultList.totalItems > 0) {
        return (
            <div className="tw-flex tw-overflow-auto">
                {resultList.currentFilters.map((filter, filterIndex) => {
                    if (filter.field === `ezids_s_M`) {
                        return filter.values.map((value, valueIndex) => (
                            <FilterChip
                                href={buildURL.withoutFilter(filter.field, value.replace(SearchSlashQuote, `"`))}
                                key={`${filterIndex}_${valueIndex}`}
                                name={filter.name}
                                value={filter.valueLabels[valueIndex]}
                            />
                        ));
                    }
                    if (filter.field === `purchasedBy_s_M`) {
                        return filter.values.map((value, valueIndex) => (
                            <FilterChip
                                href={buildURL.withoutFilter(filter.field, value.replace(SearchSlashQuote, `"`))}
                                key={`${filterIndex}_${valueIndex}`}
                                name="Previously Purchased"
                                value=""
                            />
                        ));
                    }
                    if (filter.field === `onSpecial_s_M`) {
                        return filter.values.map((value, valueIndex) => (
                            <FilterChip
                                href={buildURL.withoutFilter(filter.field, value.replace(SearchSlashQuote, `"`))}
                                key={`${filterIndex}_${valueIndex}`}
                                name="Featured"
                                value={filter.valueLabels[valueIndex]}
                            />
                        ));
                    }
                    if (filter.structuredValues) {
                        return filter.structuredValues.map((value, valueIndex) => (
                            <FilterChip
                                href={buildURL.withoutFilter(filter.field, value.id.replace(SearchSlashQuote, `"`))}
                                key={`${filterIndex}_${valueIndex}`}
                                name={filter.name}
                                pushGaEvent={pushGaEvent}
                                value={URLBuilder.cleanQuotes(value.name)}
                            />
                        ));
                    }
                    return filter.values.map((value, valueIndex) => (
                        <FilterChip
                            href={buildURL.withoutFilter(filter.field, value.replace(SearchSlashQuote, `"`))}
                            key={`${filterIndex}_${valueIndex}`}
                            name={filter.name}
                            value={URLBuilder.cleanQuotes(value.replace(FacetReplace, ``).replace(SearchSlashQuote, `"`))}
                        />
                    ));
                })}
                <a
                    className="tw-mx-4 tw-py-1 tw-text-base"
                    href={buildURL.withNoFilters()}
                >
                    <strong>CLEAR ALL</strong>
                </a>
            </div>
        );
    }
};
